$(document).ready(function () {
	init();
	bookingPopup();

	$(window).trigger('scroll');

	loadYouTubeAPI();
});

/**
 * Check if browser is IE 11 or worse
 */

function isBrowserIE() {
	var ua = window.navigator.userAgent; // Check the userAgent property of the window.navigator object
	var msie = ua.indexOf('MSIE '); // IE 10 or older
	var trident = ua.indexOf('Trident/'); //IE 11

	if (msie > 0 || trident > 0) {
		// If IE 11 or worse
		return true;
	}

	return false;
}

const hiddenSections = document.querySelectorAll('.js-hidden');

function fadeInVisible() {
	hiddenSections.forEach(function (s, i) {
		if (s.getBoundingClientRect().top <= window.innerHeight - 30) {
			s.classList.add('js-visible');
		}
	});
}

/**
 * Scrolling Animation
 */
function fadeInOnScroll() {
	// Check if internet explorer or mobile and turn off scrolling animations if so.
	if (isBrowserIE() || $(window).innerWidth() < 992) {
		$('.js-hidden').addClass('js-visible');
		// return;
	}

	$(window).on('scroll resize load', function (e) {
		fadeInVisible();
	});
}

function init() {
	let prev = $('.press-pagination__arrow.prev');
	let next = $('.press-pagination__arrow.next');

	fadeInOnScroll();
	eventDateFilter();
	pressDateFilter();
	eventCatFilter();
	disablePagination();
	pressPaginationNumber();
	/*
    Header.
     */

	const header = document.getElementById('header-bar');
	let heroHeight = window.innerHeight;

	window.addEventListener('scroll', function () {
		let scrollPosition = window.scrollY;
		if (scrollPosition >= heroHeight) {
			header.classList.add('scrolling');
		} else if (scrollPosition <= 0) {
			header.classList.remove('scrolling');
		}
	});

	/*
    Smooth scroll.
     */
	$(function () {
		$('a[href*="#"]:not([href="#"])').click(function () {
			if (
				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
				location.hostname == this.hostname
			) {
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if (target.length) {
					$('html, body').animate(
						{
							scrollTop: target.offset().top - 79,
						},
						1000
					);
					return false;
				}
			}
		});
	});

	// Events Highlight module
	if ($('.event-highlights').length) {
		$('.event-highlights').each(function (index) {
			let slider = $(this).find('.js-event-highlight-slider').attr('id');
			if (slider) {
				slider = '#' + slider;
				let parent = $(this).find('.js-event-highlight-slider').parent('div').attr('id');
				parent = '#' + parent;
				$(slider).slick({
					dots: false,
					arrows: true,
					autoplay: false,
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					prevArrow: $(parent + ' .slick-prev'),
					nextArrow: $(parent + ' .slick-next'),
				});
			}
		});
	}

	/*
    Checkbox checker.
     */
	$('.gdpr-terms .wpcf7-list-item input').on('click', function (e) {
		e.preventDefault();
		let label = $(this).parent('label');
		if (label.hasClass('checked')) {
			$(this).prop('checked', false);
			label.removeClass('checked');
		} else {
			$(this).prop('checked', true);
			label.addClass('checked');
		}
	});

	/*
    Hero slider.
     */
	$('.page-hero-slider').slick({
		infinite: false,
		dots: false,
		arrows: true,
		autoplay: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		prevArrow: $('.page-hero .slick-prev'),
		nextArrow: $('.page-hero .slick-next'),
		fade: true,
		adaptiveHeight: true,
	});

	$('.page-hero-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		if ($(slick.$slides.get(nextSlide)).hasClass('content__dark')) {
			$('.dummy-arrow').removeClass('light');
			$('.dummy-arrow').addClass('dark');
		} else {
			$('.dummy-arrow').removeClass('dark');
			$('.dummy-arrow').addClass('light');
		}
	});

	/*
    Blocks slider
     */
	$('.slick-block').each(function (index) {
		let slider = $(this).find('.single-slider').attr('id');
		if (slider) {
			slider = '#' + slider;
			let parent = $(this).find('.single-slider').parent('div').attr('id');
			parent = '#' + parent;
			$(slider).slick({
				infinite: false,
				dots: false,
				arrows: true,
				autoplay: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				prevArrow: $(parent + ' .slick-prev'),
				nextArrow: $(parent + ' .slick-next'),
				fade: true,
			});
		}
	});

	/*
    Carousel slider
     */
	$('.image-slider-section').each(function (index) {
		let slider = $(this).find('.image-carousel').attr('id');
		if (slider) {
			slider = '#' + slider;
			let parent = $(this).find('.image-carousel').parent('div').attr('id');
			parent = '#' + parent;
			$(slider).slick({
				dots: false,
				arrows: true,
				autoplay: false,
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: true,
				centerPadding: '0px',
				speed: 800,
				useTransform: true,
				cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
				prevArrow: $(parent + ' .slick-prev'),
				nextArrow: $(parent + ' .slick-next'),
			});
		}
	});

	// On before slide change
	$('.image-carousel').on(
		'beforeChange',
		function (event, { slideCount: count }, currentSlide, nextSlide) {
			let selectors = [nextSlide, nextSlide - count, nextSlide + count]
				.map((n) => `[data-slick-index="${n}"]`)
				.join(', ');
			$('.slick-now').removeClass('slick-now');
			$(selectors).addClass('slick-now');
		}
	);

	$('.image-carousel [data-slick-index="0"]').addClass('slick-now');

	/*
    Signup button launch
     */
	$('body').on('click', '.signup-button', function (e) {
		e.preventDefault();
		$('.sp-form-outer').removeClass('closed');
	});

	/*
    Singup button close
     */
	$('body').on('click', '.sp-form-outer .close', function (e) {
		e.preventDefault();
		$('.sp-form-outer').addClass('closed');
	});

	/*
    Ajax request for changing location.
     */
	function eventCatFilter() {
		$('body').on('click', '.events-post-cats--filter-wrap .cat-trigger', function (e) {
			e.preventDefault();
			if (!$(this).hasClass('active')) {
				$('.events-post-cats--filter-wrap .cat-trigger').removeClass('active');
				$(this).addClass('active');
				$.ajax({
					url: '/wp-admin/admin-ajax.php',
					type: 'POST',
					data: {
						action: 'change_location',
						location: $(this).attr('data-location'),
					},
					beforeSend: function () {
						let height = $('.events-content-section').innerHeight();
						$('.events-content-section').css('height', height + 'px');
						$('#events-posts').fadeTo(200, 0, function () {
							$('#events-posts').html(
								'<div class="loader"><div class="ball-clip-rotate"><div></div></div></div>'
							);
						});
						$('#events-posts').delay(400).fadeTo(900, 1);
					},
					success: function (data) {
						$('#events-posts')
							.delay(200)
							.fadeIn(300, function () {
								$('.events-content-section').css('height', 'unset');
								$('#events-posts .loader').remove();
								$('#events-posts').append(data);
								const hiddenSections = document.querySelectorAll('.js-hidden');

								function fadeInVisible() {
									hiddenSections.forEach(function (s, i) {
										if (
											s.getBoundingClientRect().top <=
											window.innerHeight - 30
										) {
											s.classList.add('js-visible');
										}
									});
								}

								fadeInVisible();
								$(window).on('scroll resize load', function (e) {
									fadeInVisible();
								});
							});
					},
				});
			}
		});
	}

	/*
    Ajax request for changing date on the events.
     */
	function eventDateFilter() {
		$('body').on('change', '#date-select', function () {
			let date = $(this).val();
			$.ajax({
				url: '/wp-admin/admin-ajax.php',
				type: 'POST',
				data: {
					action: 'filter_date',
					date: date,
				},
				beforeSend: function () {
					let height = $('.events-content-section').innerHeight();
					$('.events-content-section').css('height', height + 'px');
					$('#events-posts').fadeTo(200, 0, function () {
						$('#events-posts').html(
							'<div class="loader"><div class="ball-clip-rotate"><div></div></div></div>'
						);
					});
					$('#events-posts').delay(400).fadeTo(900, 1);
				},
				success: function (data) {
					$('#events-posts')
						.delay(200)
						.fadeIn(300, function () {
							$('.events-content-section').css('height', 'unset');
							$('#events-posts .loader').remove();
							$('#events-posts').append(data);
							const hiddenSections = document.querySelectorAll('.js-hidden');

							function fadeInVisible() {
								hiddenSections.forEach(function (s, i) {
									if (s.getBoundingClientRect().top <= window.innerHeight - 30) {
										s.classList.add('js-visible');
									}
								});
							}

							fadeInVisible();
							$(window).on('scroll resize load', function (e) {
								fadeInVisible();
							});
						});
				},
			});
		});
	}

	/*
    Ajax request for changing date on the events.
     */
	function pressDateFilter() {
		$('body').on('change', '#date-filter', function () {
			let date = $(this).val();
			$('.press-pagination__number').removeClass('active');
			$('.press-pagination__number#number-1').addClass('active');
			let number = $('.press-pagination__number.active').attr('data-number');
			pressDateAjax(date, number);
		});
	}

	function disablePagination() {
		let totalPosts = $('#all-posts').val();
		let postsSoFar = $('#posts-so-far').val();

		if (totalPosts == postsSoFar) {
			next.addClass('disabled');
		} else {
			next.removeClass('disabled');
		}

		if (postsSoFar <= 4) {
			prev.addClass('disabled');
		} else {
			prev.removeClass('disabled');
		}
	}

	function pressPaginationNumber() {
		$('body').on('click', '.press-pagination__number', function (e) {
			e.preventDefault();
			if (!$(this).hasClass('active')) {
				$('.press-pagination__number').removeClass('active');
				$(this).addClass('active');
				let number = $(this).attr('data-number');
				let date = $('#date-filter').val();
				pressDateAjax(date, number);
			}
		});
	}

	function pressPagination() {
		$('body').on('click', '.press-pagination__arrow', function (e) {
			e.preventDefault();
			let date = $('#date-filter').val();
			let number = $('.press-pagination__number.active').attr('data-number');
			$('.press-pagination__number').removeClass('active');

			let newActiveNumber;
			if ($(this).hasClass('prev')) {
				newActiveNumber = parseInt(number) - 1;
			} else {
				newActiveNumber = parseInt(number) + 1;
			}

			$('.press-pagination__number').each(function () {
				if ($(this).attr('data-number') == newActiveNumber) {
					$(this).addClass('active');
				}
			});

			pressDateAjax(date, newActiveNumber);
		});
	}

	pressPagination();

	function pressDateAjax(date, number) {
		$.ajax({
			url: '/wp-admin/admin-ajax.php',
			type: 'POST',
			data: {
				action: 'filter_date_press',
				date_range: date,
				number: number,
			},
			beforeSend: function () {
				let height = $('.events-content-section').innerHeight();
				$('.events-content-section').css('height', height + 'px');
				$('#events-posts').fadeTo(200, 0, function () {
					$('#events-posts').html(
						'<div class="loader"><div class="ball-clip-rotate"><div></div></div></div>'
					);
				});
				$('#events-posts').delay(400).fadeTo(900, 1);
			},
			success: function (data) {
				$('#events-posts')
					.delay(200)
					.fadeIn(300, function () {
						$('.events-content-section').css('height', 'unset');
						$('#events-posts .loader').remove();
						$('#events-posts').append(data);
						disablePagination();
						const hiddenSections = document.querySelectorAll('.js-hidden');

						function fadeInVisible() {
							hiddenSections.forEach(function (s, i) {
								if (s.getBoundingClientRect().top <= window.innerHeight - 30) {
									s.classList.add('js-visible');
								}
							});
						}

						fadeInVisible();
						$(window).on('scroll resize load', function (e) {
							fadeInVisible();
						});
					});
			},
		});
	}

	/*
    Hamburger animate.
    */
	$('.menu-trigger').click(function (e) {
		e.preventDefault();
		if ($('body').hasClass('menu-open')) {
			$('body').removeClass('menu-open');
			$('#mobile-menu-wrapper').removeClass('open');
			$('#mobile-menu-wrapper .main-menu li').removeClass('show');
			$('#header-social-nav').removeClass('js-visible');
			$('#wpml-nav').removeClass('js-visible');
			$('#mobile-menu-wrapper #open-table-wrap').removeClass('js-visible');
		} else {
			$('body').addClass('menu-open');
			$('#mobile-menu-wrapper').addClass('open');
			setTimeout(function () {
				$('#mobile-menu-wrapper .main-menu li').each(function (i) {
					var row = $(this);
					setTimeout(function () {
						row.toggleClass('show');
					}, 100 * i);
				});
				$('#header-social-nav').addClass('js-visible');
				$('#wpml-nav').addClass('js-visible');
			}, 600);
			$('#mobile-menu-wrapper #open-table-wrap').addClass('js-visible');
		}
	});

	$('.js__booking-trigger').click(function (e) {
		e.preventDefault();
		if ($('body').hasClass('menu-open')) {
			$('#booking-popup').removeClass('open');
			$('body').removeClass('menu-open');
			$('#booking-popup #open-table-wrap').removeClass('js-visible');
		} else {
			$('#booking-popup').addClass('open');
			$('body').addClass('menu-open');
			$('#booking-popup #open-table-wrap').addClass('js-visible');
		}
	});

	$(document).on('click', '.js__close-popup', function (e) {
		$('#booking-popup').removeClass('open');
		$('body').removeClass('menu-open');
		$('#open-table-wrap').removeClass('js-visible');
		$('#mobile-menu-wrapper').removeClass('open');
		$('#mobile-menu-wrapper .main-menu li').removeClass('show');
		$('#header-social-nav').removeClass('js-visible');
		$('#wpml-nav').removeClass('js-visible');
	});

	// Custom Popup code
	if ($('.custom-popup').length) {
		const cp = $('.custom-popup');
		const expiryTrigger = cp.data('expiry-trigger');
		const expiryLengthDays = parseInt(cp.data('expiry'));
		const expiryLengthSeconds = daysToSeconds(expiryLengthDays);

		// Show only if cookie banner is accepted and popup hasn't been viewed
		var userConsent = getCookie('moove_gdpr_popup');
		var thirdPartyConsent = false;
		if (userConsent) {
			var decodedConsent = decodeURIComponent(userConsent);
			var jsonConsent = JSON.parse(decodedConsent);
			console.log(jsonConsent);

			thirdPartyConsent = jsonConsent.thirdparty === '1';
		}

		if (!getLocalStorageWithExpiry('arca-popup') && thirdPartyConsent) {
			setTimeout(() => {
				$('body').addClass('popup-showing');
				cp.addClass('showing');

				if (expiryTrigger == 'on-show') {
					setLocalStorageWithExpiry('arca-popup', 'viewed', expiryLengthSeconds);
				}
			}, 1500);
		}

		$('.js__close-custom-popup').on('click', function (e) {
			$('body').removeClass('popup-showing');
			cp.removeClass('showing');

			if (expiryTrigger == 'on-close') {
				setLocalStorageWithExpiry('arca-popup', 'viewed', expiryLengthSeconds);
			}
		});
	}

	function daysToSeconds(days) {
		return days * 24 * 60 * 60;
	}

	function setLocalStorageWithExpiry(key, value, ttl) {
		const now = new Date();

		// `item` is an object which contains the original value
		// as well as the time when it's supposed to expire
		const item = {
			value: value,
			expiry: now.getTime() + ttl,
		};
		localStorage.setItem(key, JSON.stringify(item));
	}

	function getLocalStorageWithExpiry(key) {
		const itemStr = localStorage.getItem(key);
		// if the item doesn't exist, return null
		if (!itemStr) {
			return null;
		}
		const item = JSON.parse(itemStr);
		const now = new Date();

		// compare the expiry time of the item with the current time
		if (now.getTime() > item.expiry) {
			// If the item is expired, delete the item from storage
			// and return null
			localStorage.removeItem(key);
			return null;
		}
		return item.value;
	}

	function getCookie(name) {
		var nameEQ = name + '=';
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	}

	$(document).on('click', '.js__menu-toggle', function (e) {
		e.preventDefault();

		if (!$(this).hasClass('active')) {
			$('.js__menu-toggle').removeClass('active');
			$(this).addClass('active');

			var menuItems = $(this).data('menu-items');
			var minHeight = $('.js__menus-container').height();

			$('.js__menus-container').css('min-height', minHeight);

			var tlFadeOut;
			tlFadeOut = gsap.timeline({
				onComplete: () => {
					$.ajax({
						type: 'POST',
						dataType: 'html',
						url: customScriptVars.ajaxurl,
						data: {
							menu_items: menuItems,
							action: 'ajax_get_tabbed_menu_item',
						},
						success: function (data) {
							const returnedData = JSON.parse(data);

							$('.js__menus-container').html(returnedData.menus);
							let tlFadeIn;
							tlFadeIn = gsap.timeline({
								onComplete: () => {
									$('.js__menus-container').removeAttr('style');
								},
							});
							tlFadeIn.to('.js__menus-container > .container.hide-on-default', {
								autoAlpha: 1,
								duration: 0.4,
								delay: 0.05,
							});
						},
						error: function (jqXHR, textStatus, errorThrown) {
							$(this).html(
								$.parseJSON(jqXHR.responseText) +
									' :: ' +
									textStatus +
									' :: ' +
									errorThrown
							);
							console.log(jqXHR);
						},
					});
				},
			});
			tlFadeOut.to('.js__menus-container > .container', { autoAlpha: 0, duration: 0.4 });
		}
	});

	/*
        Gallery Module
    */

	//Gallery Select logic
	$('.filters li').click(function () {
		var sectionIndex = $(this).data('filter');
		console.log(sectionIndex);
		if ($(this).hasClass('active')) return;

		$(this).siblings().removeClass('active');
		$(this).addClass('active');

		$('.js__gallery-section').css('display', 'none');
		$('.js__gallery-section[data-gallery-section="' + sectionIndex + '"]').css(
			'display',
			'flex'
		);
	});

	$('.gallery-grid .gallery-image .image-wrapper').on('click', function (e) {
		e.preventDefault();
	});

	// Gallery Slider
	var i = 0;
	// Loop through to allow for multiple sliders on the page
	$('.js__gallery-slider').each(function () {
		$(this).addClass('js__gallery-slider--' + i);

		$('.js__gallery-slider--' + i).slick({
			slidesToShow: 1,
			dots: false,
			arrows: false,
			fade: true,
		});

		i++;
	});

	$('.js__open-gallery-slider').on('click', function (e) {
		e.preventDefault();

		var slideIndex = $(this).data('index');
		var sliderIndex = $(this).closest('.js__gallery-section').data('gallery-section');
		var slider = $('.js__gallery-slider--' + sliderIndex);

		slider.closest('.gallery-grid__slider-popup').addClass('is-active');
		slider.slick('slickGoTo', slideIndex);

		$('body').css('overflow', 'hidden');
	});

	$('.js__close-gallery-slider-popup').on('click', function (e) {
		e.preventDefault();
		$('.gallery-grid__slider-popup').removeClass('is-active');
		$('body').css('overflow', 'auto');
	});

	$('.gallery-grid__slider-arrow--prev').on('click', function (e) {
		$(this).siblings('.js__gallery-slider').slick('slickPrev');
	});

	$('.gallery-grid__slider-arrow--next').on('click', function (e) {
		$(this).siblings('.js__gallery-slider').slick('slickNext');
	});

	$('.gallery-grid__slider-bg').on('click', function (e) {
		$('.gallery-grid__slider-popup').removeClass('is-active');
		$('body').css('overflow', 'auto');
	});

	$(document).keydown(function (e) {
		if (e.which === 27) {
			$('.gallery-grid__slider-popup').removeClass('is-active');
			$('body').css('overflow', 'auto');
		}
		if (e.which === 37) {
			$('.gallery-grid__slider-arrow--prev')
				.siblings('.js__gallery-slider')
				.slick('slickPrev');
		}
		if (e.which === 39) {
			$('.gallery-grid__slider-arrow--next')
				.siblings('.js__gallery-slider')
				.slick('slickNext');
		}
	});
}

function setCookie(cname, cvalue) {
	var date = new Date();
	var expires = 'expires=';
	date.setDate(date.getDate() + 1);
	expires += date.toGMTString();
	document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=/';
}

function bookingPopup() {
	$('.js__selectric').selectric();

	$('.js__datepicker').each(function () {
		$(this).datepicker({
			dateFormat: 'dd/mm/yy',
			onClose: function (dateText, inst) {
				$(this).attr('disabled', false);
			},
			beforeShow: function (input, inst) {
				$(this).attr('disabled', true);
			},
		});
	});

	//Booking Form
	$('.popup__item-form').on('submit', function (e) {
		e.preventDefault();

		// Clear previous error messages
		let errorCount = 0;
		$(this).find('.popup__item-form-label--error').hide();
		let restref;
		if ($('#select-location').length) {
			restref = $('#select-location').find(':selected').val();
		} else {
			restref = $(this).find('#location').val();
		}

		let restaurant = $(this).find('#location').data('restaurant');
		let selectedDate = $(this).find('.js__datepicker').val()
			? $(this).find('.js__datepicker').val()
			: $(this).find('#backup-date').val();
		let dateArray = selectedDate.split('/');
		let day = dateArray[0];
		let month = dateArray[1];
		let year = dateArray[2];
		let arrivalDate = year + '-' + month + '-' + day;
		let selectedTime = $(this).find('#booking_time').find(':selected').val();
		let time = selectedTime.replace(':', '%3A');
		let selectedPeople = $(this).find('#people').find(':selected').val();

		if (restref == 0) {
			$(this).find('.popup__item-form-label--error').show();
			errorCount = 1;
		}

		let otURL = 'https://www.opentable.co.uk/restref/client/';
		otURL += '?rid=' + restref;
		otURL += '&datetime=' + arrivalDate + 'T' + time;
		otURL += '&searchdatetime=' + arrivalDate + 'T' + time;
		otURL += '&covers=' + selectedPeople + '&partysize=' + selectedPeople;
		otURL += '&no-r3-redirect=1';

		if (errorCount === 0) {
			window.open(otURL, '_blank');
		}
	});
}

let player;

function initYouTubePlayer() {
    console.log('Initializing YouTube Player');
    const iframe = document.getElementById('video');
    if (iframe) {
        console.log('Video iframe found:', iframe);
        let videoSrc = iframe.src;
        console.log('Video src:', videoSrc);

        if (!videoSrc || !videoSrc.includes('youtube.com')) {
            console.log('Invalid or missing src, checking data-src');
            videoSrc = iframe.getAttribute('data-src');
            console.log('Video data-src:', videoSrc);
        }

        if (videoSrc && videoSrc.includes('youtube.com')) {
            if (iframe.src !== videoSrc) {
                iframe.src = videoSrc; // Set the actual src if it's different
            }
            player = new YT.Player('video', {
                events: {
                    'onReady': onPlayerReady,
                    'onStateChange': onPlayerStateChange
                }
            });
        } else {
            console.log('No valid YouTube source found');
        }
    } else {
        console.log('Video iframe not found');
    }
}

function onPlayerReady(event) {
    console.log('Player Ready');
    document.addEventListener('visibilitychange', handleVisibilityChange);
    if (event.target && typeof event.target.playVideo === 'function') {
        event.target.playVideo();
        console.log('Attempted to play video');
    } else {
        console.log('Unable to play video');
    }
}

function onPlayerStateChange(event) {
    console.log('Player State Changed:', event.data);
    if (event.data === YT.PlayerState.PAUSED && document.visibilityState === 'visible') {
        event.target.playVideo();
        console.log('Attempted to resume paused video');
    }
}

function handleVisibilityChange() {
    console.log('Visibility Changed:', document.visibilityState);
    if (document.visibilityState === 'visible' && player && typeof player.playVideo === 'function') {
        player.playVideo();
        console.log('Attempted to play video on visibility change');
    }
}

function loadYouTubeAPI() {
    console.log('Loading YouTube API');
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

window.onYouTubeIframeAPIReady = function() {
    console.log('YouTube API Ready');
    initYouTubePlayer();
};